// ********** index.js ************
// autor: W de Paula
// data: 23/05/24 | 19h05
// ********** index.js ************



// import ReactDOM from 'react-dom' // substituída pela linha abaixo 21/5/24w;
// import Routes from './routes';
// import App from './app.jsx';

import React from 'react';
import ReactDOM from 'react-dom/client';
import Rotas from './rotas';
import { AuthProvider } from './app/Context/auth';
import "./Styles/global.css";

// Configuração inicial para o ReactDOM
const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<Rotas />
root.render(
    <AuthProvider>
        <Rotas />
    </AuthProvider>

);
